<template>
	<div id="introduce-company-detail">
		<!--返回按键-->
		<div class="backImage" @click="backFun">
			<img src="../../assets/arrow.png" />
		</div>

		<!--标题-->
		<div class="companyTitle">
			<div class="name">
				<div>{{ item.name }}</div>
			</div>

			<div class="concact">
				<div>{{ $route.query.industry_name }}</div>
				<div class="phone">{{ item.scale }}人</div>
			</div>

			<div class="location">
				<img src="../../assets/address.png" />
				<div class="address">{{ item.address }}</div>
			</div>
		</div>

		<!--内容-->
		<div class="content" v-html="item.content"></div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	data() {
		return {
			item: '',
		}
	},

	computed: {
		...mapGetters(['token', 'userId', 'communityId']),
	},

	created() {
		this.vaxios.get(
			`${this.vaxios.host}/open/api/v1/companies/${this.$route.query.id}/detail`,
			{},
			(res) => {
				if (res.code !== 1 || !res.data) return
				this.item = res.data
			},
			function(err) {
				console.log(err)
			},
			{
				headers: {
					Authorization: 'Bearer ' + this.token,
					'Content-Type': 'application/json',
				},
			}
		)
	},
	methods: {
		backFun() {
			this.$router.go(-1)
		},
	},
}
</script>

<style>
#introduce-company-detail {
	display: flex;
	flex-direction: column;
	/*justify-self: center;*/
	align-items: center;
}
.backImage {
	height: 44px;
	width: 100%;
	display: flex;
	/*background-color: aquamarine;*/
	z-index: 20;
	position: absolute;
	margin-top: 0;
	align-items: center;
}
.backImage img {
	height: 50%;
	margin-left: 15px;
}
.backgroupImage img {
	height: 12.875rem;
	width: 100%;
}
.companyTitle {
	/*position: absolute;*/
	/*margin-top: 11.09rem;*/
	height: 12.09rem;
	width: 95%;
	background-color: white;
	z-index: 20;
	display: flex;
	flex-direction: column;
	border-radius: 0.43rem;
	box-shadow: 0px 1px 22px rgba(0, 0, 0, 0.04);
}

.name {
	margin-top: 1.53rem;
	margin-left: 1.59rem;

	line-height: 1.93rem;
	font-size: 1.37rem;
	font-weight: bold;
	color: rgba(0, 0, 0, 0.85);
	display: flex;
	align-items: center;
}
.concact {
	margin-top: 0.25rem;
	margin-left: 1.59rem;
	line-height: 1.03rem;
	color: rgba(0, 0, 0, 0.45);
	font-size: 0.85rem;
	display: flex;
	/*background-color: red;*/
}
.phone {
	border-left-style: solid;
	border-left-width: 0.5px;
	padding-left: 15px;
	margin-left: 10px;
}
.business {
	margin-left: 10px;
}
.location {
	margin-top: 1.5rem;
	margin-left: 1.59rem;
	display: flex;
	align-items: center;
}
.location img {
	width: 1.25rem;
	height: 1.25rem;
}
.address {
	margin-left: 5px;
	line-height: 1.03rem;
	font-size: 0.85rem;
	color: rgba(0, 0, 0, 0.85);
}
.content {
	/*display: flex;*/
	/*position: absolute;*/
	/*margin-top: 13rem;*/
	/*z-index: 21;*/
	width: 95%;
	text-align: center;
	/*background-color: red;*/
}
</style>
